import ReactOnRails from 'react-on-rails';
import NavBar from '../../bundles/NavBar/components/NavBar.client.jsx';

ReactOnRails.register({NavBar});
